<template>
  <TargetKpiKorporatForm mode="Ubah" module="Target Indikator Kinerja"> </TargetKpiKorporatForm>
</template>

<script>
import TargetKpiKorporatForm from './form-target';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const TargetKpiKorporatUpdate = {
  name: 'TargetKpiKorporatUpdate',
  components: { TargetKpiKorporatForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default TargetKpiKorporatUpdate;
</script>
